import { Tag, Tooltip } from 'antd';
import styled from 'styled-components';

const UpcomingFallbackContainer = styled.div`
	position: relative;
	cursor: not-allowed;
	.tag {
		position: absolute;
		bottom: -30%;
		right: -20%;
		color: #ffffff;
		background-color: #f5222d;
		border-color: #f5222d;
		font-size: 10px;
		padding: 0;
		margin: 0;
		line-height: 15px;
	}
`;
export const Upcoming: React.FC<{ children: React.ReactNode; tooltipTitle: string }> = ({ children, tooltipTitle }) => {
	return (
		<Tooltip title={tooltipTitle}>
			<UpcomingFallbackContainer>
				<div style={{ opacity: 0.5, pointerEvents: 'none' }}>{children}</div>
				<Tag className="tag" color="error">
					soon
				</Tag>
			</UpcomingFallbackContainer>
		</Tooltip>
	);
};
